import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0,
  },
  mutations: {
    increment(state, value) {
      state.count++
      if(value != undefined) {
        state.count = 0
      }
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js